// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"810aefdc","455":"dbec5892"}[chunkId] + ".chunk.js";
};